import React from 'react';
import PropTypes from 'prop-types';

const SearchListItemFigure = props => (
  <figure className="afd-search-list__figure">
    <div
      className="afd-search-list__img afd-search-list__bg-img"
      style={{ backgroundImage: `url(${props.backgroundImage})` }}
    />
  </figure>
);

SearchListItemFigure.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
};

export default SearchListItemFigure;
